import React from 'react';
import {Box} from '@chakra-ui/react';
import style from './styles';

export default function DashboardServiceCardContent({children}) {
    return <Box sx={style.contentContainer}>{children}</Box>;
}
